import React, {  useState, useEffect } from "react";

export default function MARATHItest(props) {
  const correctAnswers = [2, 0, 0, 0, 1, 3, 2, 2, 2, 0, 2, 0, 0, 2, 0, 1, 0, 3, 0, 0, 3, 0, 0, 3, 3];
  const que = {
    q1: {
      string: "1. Who is considered the father of Marathi literature?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 2
    },
    q2: {
      string: "2. What is the script used to write Marathi language?",
      options: ["Devanagari", "Brahmi", "Arabic", "Latin"],
      ans: 0
    },
    q3: {
      string: "3. Which Marathi poet wrote the famous collection of poems 'Gatha'?",
      options: ["Sant Tukaram", "Sant Eknath", "Sant Dnyaneshwar", "Sant Namdev"],
      ans: 0
    },
    q4: {
      string: "4. Which Marathi sant is known for his compositions called 'Abhang'?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 0
    },
    q5: {
      string: "5. Who wrote the famous Marathi play 'Natasamrat'?",
      options: ["Vijay Tendulkar", "Vishnu Vaman Shirwadkar", "P. L. Deshpande", "Prabhakar Pendharkar"],
      ans: 1
    },
    q6: {
      string: "6. 'Pu. La. Deshpande' is known for his contribution to which form of Marathi literature?",
      options: ["Poetry", "Novel", "Short Stories", "Humor"],
      ans: 3
    },
    q7: {
      string: "7. What is the meaning of the Marathi word 'Pavsala'?",
      options: ["Summer", "Winter", "Rainy Season", "Spring"],
      ans: 2
    },
    q8: {
      string: "8. The Marathi novel 'Yayati' was written by which author?",
      options: ["P. L. Deshpande", "Vijay Tendulkar", "Vishnu Sakharam Khandekar", "Prabhakar Pendharkar"],
      ans: 2
    },
    q9: {
      string: "9. Which Marathi sant is known for his work 'Dasbodh'?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 2
    },
    q10: {
      string: "10. Which Marathi poet wrote the famous 'Amrut Anubhav'?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 2
    },
    q11: {
      string: "11. 'Vinda Karandikar' is associated with which form of Marathi literature?",
      options: ["Poetry", "Novel", "Drama", "Essay"],
      ans: 0
    },
    q12: {
      string: "12. 'Ram Ganesh Gadkari' is known for his contribution to which form of Marathi literature?",
      options: ["Poetry", "Novel", "Drama", "Short Stories"],
      ans: 2
    },
    q13: {
      string: "13. 'Shanta Shelke' is renowned for her work in which field of Marathi literature?",
      options: ["Poetry", "Novel", "Drama", "Children's Literature"],
      ans: 0
    },
    q14: {
      string: "14. What is the meaning of the Marathi word 'Sahitya'?",
      options: ["History", "Geography", "Literature", "Science"],
      ans: 2
    },
    q15: {
      string: "15. Who is considered the first female Marathi poet?",
      options: ["Muktabai", "Savitribai Phule", "Janabai", "Sakhubai"],
      ans: 0
    },
    q16: {
      string: "16. Which Marathi sant is known for his 'Abhanga Gatha'?",
      options: ["Sant Namdev", "Sant Tukaram", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 1
    },
    q17: {
      string: "17. Who is known as the 'Acharya' of Marathi literature?",
      options: ["Sant Dnyaneshwar", "Sant Eknath", "Sant Tukaram", "Sant Namdev"],
      ans: 0
    },
    q18: {
      string: "18. What is the meaning of the Marathi word 'Katha'?",
      options: ["Poetry", "Novel", "Story", "Drama"],
      ans: 2
    },
    q19: {
      string: "19. Who is known as the 'Sant Kavi' (saint poet) in Marathi literature?",
      options: ["Sant Dnyaneshwar", "Sant Eknath", "Sant Tukaram", "Sant Namdev"],
      ans: 2
    },
    q20: {
      string: "20. Which Marathi poet is known for his philosophical work 'Jnaneshwari'?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 2
    },
    q21: {
      string: "21. The Marathi novel 'Mrityunjay' is based on the life of which historical figure?",
      options: ["Shivaji Maharaj", "Peshwa Bajirao I", "Sambhaji Maharaj", "Chhatrapati Shahu Maharaj"],
      ans: 0
    },
    q22: {
      string: "22. Which Marathi poet is known for his devotional songs called 'Abhang'?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 0
    },
    q23: {
      string: "23. 'Kusumagraj' is the pen name of which Marathi poet?",
      options: ["Vishnu Vaman Shirwadkar", "P. L. Deshpande", "Vijay Tendulkar", "Vinda Karandikar"],
      ans: 0
    },
    q24: {
      string: "24. Which Marathi poet is known for his work 'Manache Shlok'?",
      options: ["Sant Tukaram", "Sant Namdev", "Sant Dnyaneshwar", "Sant Eknath"],
      ans: 3
    },
    q25: {
      string: "25. The Marathi novel 'Swami' was written by which author?",
      options: ["P. L. Deshpande", "Vijay Tendulkar", "Vishnu Sakharam Khandekar", "Ranjeet Desai"],
      ans: 3
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1><span>MARATHI </span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
